export default __webpack_public_path__ + "static/media/hash-extracts.6ce9f84a.jpg";